import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import classes from './laser-engraved-embelishment-method-popup.scss';
export const LaserEngravedEmbelishmentMethodPopupComponent = ({
  open,
  methodId,
  onClose
}) => {
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.paragraph
  }, "Laser engraving will remove material from the surface of the item, which means your artwork will be the color of the under layer. After you place your order, we will send you a virtual mock-up so you can approve the design before it goes into production."), /*#__PURE__*/React.createElement(Button, {
    dataButton: "Continue",
    className: classes.button,
    type: ButtonType.primary,
    onClick: () => onClose(methodId)
  }, "Continue"));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: "Keep in mind, your design will not be printed using your Pantone color!",
    dataPopup: "LaserEngravedEmbellishmentMethodPopup",
    titleClasses: {
      root: classes.header
    },
    content: content,
    onClose: onClose,
    showCloseButton: true,
    open: open,
    isResponsive: true
  });
};